export const hasActivePlan = (plan) => {
  if (!plan) return false;
  if (typeof plan.planActive === 'boolean') return plan.planActive;
  return Boolean(plan.name);
};

export const getPlanDisplayName = (plan) =>
  plan?.name
  || plan?.planName
  || plan?.previous_plan?.description
  || plan?.previous_plan?.name
  || 'Plan';
